// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn--bNHdp","inactive":"inactive--gsB0L","editable":"editable--vY6XS"};